import React from "react";
import { HomeGuideBannerWrapper } from "./HomeGuideBannerStyle";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AddHomePng from "assets/images/home-banner/Group_1959.png";
import CommunityGuidePng from "assets/images/home-banner/Group_1960.png";
import ServiceIntroGuidePng from "assets/images/home-banner/Group_1961.png";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const HomeGuideBanner = () => {
  const router = useNavigate();
  const sliderOptions = {
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    fade: true,
    appendDots: (dots) => (
      <div
        style={{
          width: "100%",
          position: "absolute",
          bottom: "2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ul> {dots} </ul>
      </div>
    ),
    dotsClass: "dots_custom",
  };
  return (
    <HomeGuideBannerWrapper>
      <Slider {...sliderOptions}>
        <BannerImage
          src={ServiceIntroGuidePng}
          alt=""
          onClick={() => router("/intro")}
        />
        <BannerImage src={AddHomePng} alt="Guide Banner" />
        <BannerImage
          src={CommunityGuidePng}
          alt=""
          onClick={() => router("/community-guide")}
        />
      </Slider>
    </HomeGuideBannerWrapper>
  );
};

export default HomeGuideBanner;

const BannerImage = styled.img`
  cursor: pointer;
`;
